<p-table
  *ngIf="dataConfig.dataType === 'technical'"
  [value]="technicalData"
  [loading]="loading"
  [rowHover]="true"
  responsiveLayout="scroll"
  [scrollable]="true"
  scrollHeight="78vh"
  [tableStyle]="{ 'min-width': '30rem' }"
  styleClass="app-table technical-records-table p-datatable-sm lg:p-datatable-md"
>
  <ng-template pTemplate="caption">
    <div
      class="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-3 py-2"
    >
      <div class="text-800 font-medium">Technical Records</div>

      <div class="w-full md:w-auto">
        <span class="p-input-icon-left p-input-icon-right w-full">
          <i class="pi pi-search"></i>
          <input
            pInputText
            type="text"
            class="w-full md:w-20rem"
            [value]="searchValue"
            (input)="filterGlobal($event)"
            placeholder="Search keyword"
          />
          <i
            *ngIf="searchValue"
            class="pi pi-times"
            style="cursor:pointer"
            (click)="clearSearch()"
          ></i>
        </span>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="header">
    <tr>
      <th *ngFor="let col of columns" [pSortableColumn]="col.field">
        <div class="flex align-items-center">
          <span>{{ col.header }}</span>
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </div>
      </th>
      <th></th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-record>
    <tr>
      <td class="mono-cell">{{ record.date_completed }}</td>
      <td class="mono-cell">{{ record.odometer }}</td>
      <td><span class="record-tag">{{ record.record_type }}</span></td>

      <!-- jobs -->
      <td>
        <div class="job-chip-list">
          <div
            *ngFor="let job of record.technical_record_jobs"
            class="job-chip"
          >
            <span class="job-chip__title">
              {{ job.job_description }}
            </span>

            <span class="job-chip__remark" *ngIf="job.remarks">
              {{ job.remarks }}
            </span>

            <button
              pButton
              icon="pi pi-trash"
              class="p-button-sm p-button-text p-button-danger job-chip__delete"
              (click)="showDeleteJob(job); $event.stopPropagation()"
            ></button>
          </div>
        </div>
      </td>

      <!-- menu -->
      <td class="text-right">
        <button
          pButton
          icon="pi pi-ellipsis-v"
          class="p-button-sm p-button-text"
          (click)="storeTechnicalRecordDetail(record); menu.toggle($event); $event.stopPropagation()"
        ></button>

        <p-menu #menu [model]="items" [popup]="true" appendTo="body"></p-menu>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="100%">
        <div class="flex align-items-center justify-content-center py-4">
          <p-progressBar
            *ngIf="isLoading"
            mode="indeterminate"
            styleClass="w-full"
          ></p-progressBar>

          <span *ngIf="!isLoading" class="text-600">
            No technical records found
          </span>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>
